export function determineAdditionalInformationLinesForLineItem(lineItem, additionalInformationLines) {
    if (lineItem.originalId && additionalInformationLines && additionalInformationLines.length > 0) {
        return additionalInformationLines
            .filter((additionalLine) => {
                return (
                    additionalLine.linkedLineItemId !== undefined &&
                    additionalLine.linkedLineItemId === lineItem.originalId
                );
            })
            .sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : a.sequenceNumber < b.sequenceNumber ? -1 : 0));
    }
}
